import { render } from "./BottomNavbar.vue?vue&type=template&id=2de98872&scoped=true"
import script from "./BottomNavbar.vue?vue&type=script&lang=js"
export * from "./BottomNavbar.vue?vue&type=script&lang=js"

import "./BottomNavbar.vue?vue&type=style&index=0&id=2de98872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de98872"]])

export default __exports__